import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from "firebase/analytics";

// TODO: Replace the following with your app's Firebase project configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAU-f1HA5GIc6Z6TN6ePx9panDxX8891Ts",
  authDomain: "my-portfolio-a2c8a.firebaseapp.com",
  projectId: "my-portfolio-a2c8a",
  storageBucket: "my-portfolio-a2c8a.appspot.com",
  messagingSenderId: "504377675757",
  appId: "1:504377675757:web:991c41b00327c6388221e4",
  measurementId: "G-VDCDHLH9V1"
};

const app = initializeApp(firebaseConfig);
// Initialize Analytics and get a reference to the service
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth,analytics};
